import {Component} from "@angular/core";
import {PriceLevelEntityModel} from "../price-level-entity.model";
import {PriceLevelSearchModel} from "../price-level-search.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-price-level-search-page",
    templateUrl: "./price-level-search-page.component.html",
    providers: [provideSearchModel(PriceLevelSearchModel), provideEntityModel(PriceLevelEntityModel)]
})

export class PriceLevelSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
